import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDetectedApplicationsByIdSlice } from './get';

export const coreDataSecurityDetectedApplicationsByIdReducers = combineReducers({
	get: getCoreDataSecurityDetectedApplicationsByIdSlice.asyncReducers
});

export const coreDataSecurityDetectedApplicationsByIdWatchers = combineAllWatchers([
	getCoreDataSecurityDetectedApplicationsByIdSlice.asyncWatchers
]);
